import { render, staticRenderFns } from "./SimpleEditor.vue?vue&type=template&id=884aac70"
import script from "./SimpleEditor.vue?vue&type=script&lang=js"
export * from "./SimpleEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports